import { render, staticRenderFns } from "./staffSelect.vue?vue&type=template&id=edfc3584&scoped=true&"
import script from "./staffSelect.vue?vue&type=script&lang=js&"
export * from "./staffSelect.vue?vue&type=script&lang=js&"
import style0 from "./staffSelect.vue?vue&type=style&index=0&id=edfc3584&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfc3584",
  null
  
)

export default component.exports